export const uiState: any = {
  state: {
    layout: "app-layout",
    miniMenu: false,
    drawer: null,
    darkMode: localStorage.getItem("qlm-darkMode") === "true" ? true : false
  },
  mutations: {
    SET_LAYOUT(state: any, payload: any) {
      state.layout = payload;
    },
    UI_TOGGLE_MINI_MENU(state: any) {
      state.miniMenu = !state.miniMenu;
    },
    UI_TOGGLE_MENU(state: any) {
      state.miniMenu = false;
      state.drawer = !state.drawer;
    },
    UI_TOGGLE_DARK_MODE(state: any) {
      state.darkMode = !state.darkMode;
      localStorage.setItem("qlm-darkMode", state.darkMode);
    }
  },
  getters: {
    layout(state: any) {
      return state.layout;
    }
  }
};
